import { SvgIconBase, } from "./Base";
import EthImg from "./Eth.png";


export const Eth = () => {
	return (
		<SvgIconBase width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-label="Ethereum">
			<title>Ethereum</title>
			<image
				href={EthImg}
				x="0"
				y="0"
				width="24"
				height="24"
				preserveAspectRatio="xMidYMid meet"
			/>
		</SvgIconBase>
	);
};

